import * as React from "react";
import { ISettings, SettingsContextType } from "Models/ISettings";
import { instance } from 'Services/instance'
import CommonApiPaths from "Application/Common/Constants/CommonApiPaths";
import Const from 'Utils/Consts';
import CacheNames from "Application/Common/Constants/CacheNames";
import { getCache, setCache } from "Application/Common/utils/CacheManagement";

const SettingsContext = React.createContext<SettingsContextType | null>({
    ...window.env
})

export let cachedSettings: ISettings | null = null

export const SettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [settings, setSettings] = React.useState<ISettings | null>(null)
    const [loading, setLoading] = React.useState<boolean>(true)

    React.useEffect(() => {
        getCache(CacheNames.ConfigsByAppKey).then(resdata => {
            if (resdata) {
                var settings = {
                    ...Const.env
                }
                Object.keys(resdata).forEach((key) => {
                    let value = resdata[key];

                    if (!isNaN(value) && value.trim() !== "") {
                        value = value.includes(".") ? parseFloat(value) : parseInt(value);
                    } else if (value === "true" || value === "false") {
                        value = value === "true";
                    }

                    settings[key] = value;
                });
                cachedSettings = settings
                setSettings(settings)
                setLoading(false)

            } else
                loadData()
        })
    }, [])

    const loadDataFromCache = async () => {
        return await getCache(CacheNames.ConfigsByAppKey)
    }
    const loadData = async () => {
        await instance.get(CommonApiPaths.settings.GetAllSettings, { timeout: 10000 })
            .then((res) => {
                var settings = {
                    ...Const.env
                }
                if (res.status === 200) {
                    setCache(CacheNames.ConfigsByAppKey, res.data)

                    Object.keys(res.data).forEach((key) => {
                        let value = res.data[key];

                        if (!isNaN(value) && value.trim() !== "") {
                            value = value.includes(".") ? parseFloat(value) : parseInt(value);
                        } else if (value === "true" || value === "false") {
                            value = value === "true";
                        }

                        settings[key] = value;
                    });
                    cachedSettings = settings
                    setSettings(settings)
                    setLoading(false)
                }
            })
            .catch((error) => {
                var settings = {
                    ...Const.env
                }
                setLoading(false)
                console.error(error)
            })
    }

    return (
        <SettingsContext.Provider value={{ settings, loading }}>
            {!loading && children}
        </SettingsContext.Provider>
    )
}

export const useSettings = (): SettingsContextType => {
    const context = React.useContext(SettingsContext)
    if (!context) {
        throw new Error("Settings Not Found...")
    }
    return context
}